<div fxLayout="column" fxLayoutGap="16px">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <p class="page-title">Andamento das Provas</p>
    <a mat-stroked-button [routerLink]="['..']">
      <mat-icon>arrow_back</mat-icon> Voltar para Configuração
    </a>
  </div>

  <div *ngIf="loading" fxLayout="row" fxLayoutAlign="center center" style="padding: 40px">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading && dados">

  <div *ngIf="dados.pendenciasFase?.length > 0">
    <mat-card class="alerta-card">
      <mat-card-content>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <mat-icon color="warn">warning</mat-icon>
          <div>
            <strong>Pendências da fase:</strong>
            <div *ngFor="let p of dados.pendenciasFase">• {{ p }}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" class="fases-container">

    <!-- FASE 1 -->
    <mat-card fxFlex="50" class="stage-card">
      <mat-card-header class="stage-header" [ngClass]="{'header-cinza': isFaseInativa('FASE1')}">
        <mat-card-title class="stage-title">FASE 1</mat-card-title>
        <div class="status-chip" [ngClass]="getStatusChipClass('FASE1')">
          <mat-icon>{{ getStatusIcon('FASE1') }}</mat-icon>
          <span>{{ getStatusLabel('FASE1') }}</span>
        </div>
      </mat-card-header>
      <mat-card-content [class.disabled-content]="isFaseInativa('FASE1')">
        <div class="exams-grid">
          <ng-container *ngFor="let prova of provasFase1">
            <ng-container *ngTemplateOutlet="provaCard; context: { $implicit: prova }"></ng-container>
          </ng-container>
        </div>
        <p *ngIf="provasFase1.length === 0" class="sem-provas">Nenhuma prova na primeira fase</p>
      </mat-card-content>
    </mat-card>

    <!-- FASE 2 -->
    <mat-card fxFlex="50" class="stage-card">
      <mat-card-header class="stage-header" [ngClass]="{'header-cinza': isFaseInativa('FASE2')}">
        <mat-card-title class="stage-title">FASE 2</mat-card-title>
        <div class="status-chip" [ngClass]="getStatusChipClass('FASE2')">
          <mat-icon>{{ getStatusIcon('FASE2') }}</mat-icon>
          <span>{{ getStatusLabel('FASE2') }}</span>
        </div>
      </mat-card-header>
      <mat-card-content [class.disabled-content]="isFaseInativa('FASE2')">
        <div class="exams-grid">
          <ng-container *ngFor="let prova of provasFase2">
            <ng-container *ngTemplateOutlet="provaCard; context: { $implicit: prova }"></ng-container>
          </ng-container>
        </div>
        <p *ngIf="provasFase2.length === 0" class="sem-provas">Nenhuma prova na segunda fase</p>
      </mat-card-content>
    </mat-card>

  </div>
  </ng-container>
</div>

<ng-template #provaCard let-prova>
  <div class="exam-card" [ngClass]="{'exam-completed': prova.concluido}">
    <div class="exam-info">
      <div class="exam-title-container">
        <span class="exam-title">{{ getNomeProva(prova.tipoProva) }}</span>
        <span class="spacer"></span>
        <mat-icon *ngIf="prova.concluido && !(isUltimaProvaFase2(prova) && temEmpatesPendentes(prova))" class="icon-concluido" matTooltip="Prova concluída">check_circle</mat-icon>
        <mat-icon *ngIf="prova.concluido && isUltimaProvaFase2(prova) && temEmpatesPendentes(prova)" class="icon-empate" matTooltip="Empates pendentes de resolução">gavel</mat-icon>
        <mat-icon *ngIf="prova.emAndamento" class="icon-andamento" matTooltip="Prova em andamento">hourglass_empty</mat-icon>
      </div>
      <span class="exam-meta">Peso: {{ prova.provaPeso }}</span>
    </div>
    <div *ngIf="(prova.emAndamento || (isUltimaProvaFase2(prova) && temEmpatesPendentes(prova))) && prova.examinadores?.length > 0" class="examinadores-resumo">
      <div *ngFor="let ex of prova.examinadores" class="examinador-linha">
        <span class="nome" [matTooltip]="ex.nome + (ex.matricula ? ' - Matrícula: ' + ex.matricula : '')">{{ ex.nome }}</span>
        <div class="notas-info" matTooltip="Notas digitadas">
          <span class="notas-numeros" [ngClass]="{'completo': ex.notasDigitadas === ex.totalInscricoes}">
            {{ ex.notasDigitadas }} / {{ ex.totalInscricoes }}
          </span>
          <mat-icon *ngIf="ex.notasDigitadas === ex.totalInscricoes" class="icon-ok">check_circle</mat-icon>
          <mat-icon *ngIf="ex.notasDigitadas !== ex.totalInscricoes" class="icon-pendente">pending</mat-icon>
        </div>
        <mat-icon [class.enviado]="ex.envelopeEnviado" [class.pendente]="!ex.envelopeEnviado"
                  [matTooltip]="ex.envelopeEnviado ? 'Envelope depositado' : 'Envelope pendente'">
          {{ ex.envelopeEnviado ? 'mark_email_read' : 'mail_outline' }}
        </mat-icon>
        <mat-icon *ngIf="ex.possuiEmpate" class="icon-empate" matTooltip="Empate pendente de resolução">gavel</mat-icon>
      </div>
    </div>
  </div>
</ng-template>
